<template>
  <!-- 带input的下拉选择器组件 -->
  <div class="xm-select-input">
    <div>
      <el-select
        clearable
        v-model="selectVaule"
        :placeholder="placeholder"
        :popper-append-to-body="appendBody"
        @change="onChange"
        @clear="clearVal"
        :style="{ width: width }"
      >
        <el-option
          v-for="item in optionData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div :style="{ width: inputWidth }">
      <el-input
        class="search-input"
        v-model="inputValue"
        size="small"
        :placeholder="inputPlaceholder"
        @keyup.enter.native="onBtn"
        @clear="onBtn"
        :clearable="isInputClearable"
      >
        <i slot="suffix" class="iconfont search-icon" @click="onBtn"
          >&#xe689;</i
        >
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XmSelect',
  data() {
    return {
      selectVaule: '', // 选项的val
      inputValue: '', // input的val值
    };
  },
  props: {
    width: {
      // 选择器的宽度
      type: String,
      default: '112px',
    },
    inputWidth: {
      // input的宽度
      type: String,
      default: '157px',
    },
    optionData: {
      // 选项数据
      type: Array,
      default: () => [],
    },
    // placeholder: {
    //   // 下拉选择的placeholder
    //   type: String,
    //   default: '请选择',
    // },
    inputPlaceholder: {
      // input框的placehoder
      type: String,
      default: '关键词',
    },
    appendBody: {
      type: Boolean,
      default: false,
    },
    // 这里是判断点击重置的时候是否要传值出去
    isReDataUp: {
      type: Boolean,
      default: false,
    },
    selectData: {
      type: Object,
      default: () => {
        // return {
        //   key:'',
        //   value:''
        // }
      },
    },
    isInputClearable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    placeholder() {
      return this.optionData.length > 0 ? this.optionData[0].label : '';
    },
  },
  watch: {
    selectData: {
      handler(newVal) {
        this.setValue(newVal?.key, newVal?.valus);
      },
      deep: true,
    },
  },
  methods: {
    // 放大镜点击事件
    onBtn() {
      if (this.selectVaule == '') {
        this.selectVaule = this.optionData[0].value;
      }
      this.onSearch();
    },
    // 传值出去的方法
    onSearch() {
      this.$emit('change', this.selectVaule, this.inputValue);
    },
    // 切换下拉框值的方法
    onChange() {
      this.inputValue = '';
      this.$emit('change-prop', this.selectVaule, this.inputValue);
    },
    // 点击清空按钮的方法
    clearVal() {
      this.inputValue = '';
      this.onSearch();
    },
    // 设置下拉框的值和输入框的值
    reVal(selectVaule = '', inputValue = '') {
      this.selectVaule = selectVaule;
      this.inputValue = inputValue;
      if (this.isReDataUp) {
        this.onSearch();
      }
    },
    // 设置下拉框的值，单纯设置，不包含其他操作
    setValue(selectVaule = '', inputValue = '') {
      this.selectVaule = selectVaule;
      this.inputValue = inputValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.xm-select-input {
  display: flex;

  .search-input {
    ::v-deep .el-input__inner {
      border-left: 0px;
      padding-right: 44px;
    }
    ::v-deep .el-input__inner:hover {
      border-left-color: #c0c4cc;
    }
    ::v-deep .el-input__inner:focus {
      border-left: 1px solid #026bff;
    }

    ::v-deep .el-input__suffix {
      right: 0;

      .search-icon {
        font-size: 18px;
        padding-right: 8px;
        position: absolute;
        top: 50%;
        right: 18px;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }
  }

  ::v-deep .el-input__inner {
    height: 40px;
    border-radius: 0px;
    padding-right: 40px;
    color: #808080;
  }

  ::v-deep .el-select-dropdown__item {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
  }
  ::v-deep .el-select-dropdown__item:hover,
  .el-select-dropdown__item.hover {
    background-color: rgba(2, 107, 255, 0.1) !important;
  }

  ::v-deep .el-select-dropdown__item.selected {
    font-weight: 400 !important;
  }
}
</style>
